<div *ngIf="irisModalRef && irisModalRef?.config?.data.isOpened == true">
  <h2 data-dd-privacy="allow">Add client to SonderMind</h2>
  <div>
    <error-list [error_list]="error_list" [system_errors]="system_errors"></error-list>
    <calendar-embedded-client-creator
      #patientModal
      [user]="irisModalRef?.config?.data.user"
      (patientCreated)="patientAdded($event)"
      (canceled)="onCancel()"
    ></calendar-embedded-client-creator>
  </div>
</div>
